import { Image } from 'pcln-design-system'
import styled from 'styled-components'

export const StyledImage = styled(Image)`
  margin: auto;
  padding-bottom: 8px;
  padding-top: 8px;
`
